var React = require('react');

function Ball26 (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.008 0.008)"},React.createElement("g",{"transform":"translate(-0.008 -0.008)"},React.createElement("g",{"id":"Group_432","data-name":"Group 432"},React.createElement("path",{"d":"M72.646,49.992,95.3,27.338A16.019,16.019,0,1,0,72.646,4.683L49.992,27.338,27.338,4.683A16.019,16.019,0,1,0,4.683,27.338L27.338,49.992,4.683,72.646A16.019,16.019,0,0,0,27.338,95.3L49.992,72.646,72.646,95.3A16.019,16.019,0,1,0,95.3,72.646Z","transform":"translate(0.008 0.008)"})))));
}

Ball26.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = Ball26;

Ball26.default = Ball26;
